import { call, put, takeLatest } from "redux-saga/effects";
import * as actiontypes from "../ActionTypes";
import {
  saveProgramCoverImageSuccess,
  saveProgramCoverImageFailure,
  updateProgramCoverImageSuccess,
  updateProgramCoverImageFailure,
  deleteProgramCoverImageSuccess,
  deleteProgramCoverImageFailure
} from "./actions";
import {
  saveProgramCoverImageApi,
  updateProgramCoverImageApi,
  deleteProgramCoverImageApi
} from "./programCoverImage";

// 🔹 SAVE PROGRAM COVER IMAGE
function* saveProgramCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};
    const data = yield call(saveProgramCoverImageApi, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(saveProgramCoverImageSuccess(data.data || apiPayloadRequest));
      if (callback) callback({ type: 1, data: data.data });
    } else {
      yield put(saveProgramCoverImageFailure(data?.error || "Save failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(saveProgramCoverImageFailure(error.message));
    if (action.payload?.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}

// 🔹 UPDATE PROGRAM COVER IMAGE
function* updateProgramCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload;
    const data = yield call(updateProgramCoverImageApi, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(updateProgramCoverImageSuccess(data?.data || apiPayloadRequest));
      if (callback) callback({ type: 1, data: data?.data });
    } else {
      yield put(updateProgramCoverImageFailure(data?.error || "Update failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(updateProgramCoverImageFailure(error.message));
    if (action.payload?.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}
// 🔹 DELETE PROGRAM COVER IMAGE
function* deleteProgramCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};

    const data = yield call(deleteProgramCoverImageApi, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(deleteProgramCoverImageSuccess(apiPayloadRequest));
      if (callback) callback({ type: 1, data });
    } else {
      yield put(deleteProgramCoverImageFailure(data?.error || "Delete failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
        yield put(deleteProgramCoverImageFailure(error.message));
    if (action.payload?.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}

// 🔹 WATCHER
export default function* programCoverImageWatcherSaga() {
  yield takeLatest(actiontypes.SAVE_PROGRAM_COVERIMAGE_REQUEST, saveProgramCoverImageSaga);
  yield takeLatest(actiontypes.UPDATE_PROGRAM_COVERIMAGE_REQUEST, updateProgramCoverImageSaga);
  yield takeLatest(actiontypes.DELETE_PROGRAM_COVERIMAGE_REQUEST, deleteProgramCoverImageSaga);

}
